module.exports = require('../_components/@alicd/next-tag/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/tag/index.js
// module id = 708
// module chunks = 0